import { render, staticRenderFns } from "./DetailsItem.vue?vue&type=template&id=6c9ef69f"
import script from "./DetailsItem.vue?vue&type=script&lang=js"
export * from "./DetailsItem.vue?vue&type=script&lang=js"
import style0 from "./DetailsItem.vue?vue&type=style&index=0&id=6c9ef69f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports